/* eslint-disable react/prop-types */
// import 'antd/dist/antd.css';
import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { Row, Col, Button } from 'antd';
// import {
//     APPOINTMENT_REQUEST_TODAY,
//     APPOINTMENT_REQUEST_UPCOMING,
//     APPOINTMENT_REQUEST_PAST,
// } from './constants';
import './style.css';
import { pastAppointmentsRequest, todayAppointmentsRequest, upComingAppointmentsRequest } from './Actions';
import { useDispatch } from 'react-redux';
import { AppointmentTileHeader } from '../CommonText';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const Responsiveheader = (props) => {
    // const [selected, setSelected] = useState('1');
    const [viewportWidth, setViewportWidth] = useState(0);
    const dispatch = useDispatch();

    let mobileBreakPoint = 772;
    let applyViewportChange = 250;

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    const handlekey1 = () => {
        // localStorage.setItem('PAGENO', 1);
        props.setSelected('1');
        props.setCurrent(1);
        // dispatch({ type: APPOINTMENT_REQUEST_TODAY, payload: '1' });
        dispatch(todayAppointmentsRequest(1));
    
    };

    const handlekey2 = () => {
        // localStorage.setItem('PAGENO', 1);
        props.setSelected('2');
        props.setCurrent(1);
        // dispatch({ type: APPOINTMENT_REQUEST_UPCOMING, payload: '2' });
        dispatch(upComingAppointmentsRequest(1));
    };

    const handlekey3 = () => {
        localStorage.setItem('PAGENO', 1);
        props.setSelected('3');
        props.setCurrent(1);
        dispatch(pastAppointmentsRequest(1));
    // dispatch({ type: APPOINTMENT_REQUEST_PAST, payload: '3' });
    };

    useEffect(() => {
        const saveViewportDimensions = throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange);

        saveViewportDimensions(); // Call initially to set the viewport width

        window.addEventListener('resize', saveViewportDimensions);

        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [applyViewportChange]);

    if (viewportWidth > mobileBreakPoint) {
        return (
            <Row justify="center" type="flex">
                <Col span={24}>
                    {props.selected === '1' ? (
                        <Button
                            onClick={handlekey1}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '234px',
                                height: '50px',
                                marginLeft: '1%',
                                borderRadius: '4px',
                                color: '#fff',
                                background: '#1890ff',
                                fontSize: '18px',
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.TodaysAppointments ? langdata.TodaysAppointments : 'Todays Appointments' }` } color = '#ffffff' />
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey1}>
                            <AppointmentTileHeader  text = {`${langdata.TodaysAppointments ? langdata.TodaysAppointments : 'Todays Appointments' }` } />
                        </Button>
                    )}

                    {props.selected === '2' ? (
                        <Button
                            onClick={handlekey2}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '234px',
                                height: '50px',
                                marginLeft: '1%',
                                borderRadius: '4px',
                                color: '#fff',
                                background: '#1890ff',
                                fontSize: '18px',
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.UpcomingAppointments ? langdata.UpcomingAppointments : 'Upcoming Appointments' }`} color = '#ffffff'/>
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey2}>
                            <AppointmentTileHeader  text =  {`${langdata.UpcomingAppointments ? langdata.UpcomingAppointments : 'Upcoming Appointments' }`} />
                        </Button>
                    )}
                    {props.selected === '3' ? (
                        <Button
                            onClick={handlekey3}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '234px',
                                height: '50px',
                                borderRadius: '4px',
                                color: '#fff',
                                marginLeft: '1%',
                                marginTop: '20px',
                                fontSize: '18px',
                                background: '#1890ff',
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.PastAppointments ? langdata.PastAppointments : 'Past Appointments' }`} color = '#ffffff' />
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey3}>
                            <AppointmentTileHeader  text = {`${langdata.PastAppointments ? langdata.PastAppointments : 'Past Appointments' }`} />
                        </Button>
                    )}
                </Col>
            </Row>
        );
    }

    return (
        <Col>
            <Row justify="center" type="flex">
                <Col span={24} style={{ height: '90px', background: '#FFFFFF', margin : '10px' }}>
                    {props.selected === '1' ? (
                        <Button
                            onClick={handlekey1}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '80px',
                                height: '40px',
                                borderRadius: '4px',
                                color: '#fff',
                                background: '#1890ff',
                                marginLeft : 'inherit'
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.Todays ? langdata.Todays : 'Todays' }`} color = '#ffffff'/>
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey1}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '80px',
                                height: '40px',
                                borderRadius: '4px',
                                marginLeft : 'inherit'
                            }}>
                            <AppointmentTileHeader  text = {`${langdata.Todays ? langdata.Todays : 'Todays' }`} />
                        </Button>
                    )}

                    {props.selected === '2' ? (
                        <Button
                            onClick={handlekey2}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '90px',
                                height: '40px',
                                borderRadius: '4px',
                                color: '#fff',
                                background: '#1890ff',
                                marginLeft : 'inherit'
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.Upcoming ? langdata.Upcoming : 'Upcoming' }`} color = '#ffffff'/>
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey2}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '90px',
                                height: '40px',
                                borderRadius: '4px',
                            }}>
                            <AppointmentTileHeader  text = {`${langdata.Upcoming ? langdata.Upcoming : 'Upcoming' }`} />
                        </Button>
                    )}
                    {props.selected === '3' ? (
                        <Button
                            onClick={handlekey3}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '80px',
                                height: '40px',
                                borderRadius: '4px',
                                color: '#fff',
                                background: '#1890ff',
                                marginLeft : 'inherit'
                            }}
                        >
                            <AppointmentTileHeader  text = {`${langdata.Past ? langdata.Past : 'Past' }`} color = '#ffffff'/>
                        </Button>
                    ) : (
                        <Button className="ant-button heading-normal" onClick={handlekey3}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                width: '80px',
                                height: '40px',
                                borderRadius: '4px',
                                marginLeft : 'inherit'
                            }}>
                            <AppointmentTileHeader  text = {`${langdata.Past ? langdata.Past : 'Past' }`} />
                        </Button>
                    )}
                </Col>
            </Row>
        </Col>
    );
};

Responsiveheader.propTypes = {
    mobileBreakPoint: PropTypes.number,
    applyViewportChange: PropTypes.number,
};

Responsiveheader.defaultProps = {
    mobileBreakPoint: 772,
    applyViewportChange: 250,
};

export default Responsiveheader;
